class SCopyCode extends HTMLElement {
  #ac;
  #announcementFrame;
  #resetTimer;

  connectedCallback() {
    this.#ac?.abort();
    this.#ac = new AbortController();

    this.addEventListener('command', (event) => {
      if (event.command === '--copy-code') this.#copy(event.source);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.#resetTimer);
    cancelAnimationFrame(this.#announcementFrame);
  }

  async #copy(source) {
    if (!(source instanceof HTMLButtonElement)) return;

    const code = this.dataset.code?.trim();
    const feedback = this.querySelector('[data-copy-feedback]');
    if (!code || !feedback) return;

    let copied = false;
    try {
      if (typeof navigator.clipboard?.writeText === 'function') {
        await navigator.clipboard.writeText(code);
        copied = true;
      }
    } catch {
      copied = false;
    }

    if (!copied) copied = this.#copyWithSelection(code, source);

    clearTimeout(this.#resetTimer);
    if (copied) {
      source.textContent = this.dataset.copySuccess;
      this.#announce(feedback, this.dataset.copySuccess);
      this.#resetTimer = window.setTimeout(() => {
        if (source.isConnected) source.textContent = this.dataset.copyLabel;
      }, 1800);
    } else {
      this.#selectVisibleCode();
      this.#announce(feedback, this.dataset.copyError);
    }
  }

  #copyWithSelection(code, source) {
    const input = document.createElement('textarea');
    input.value = code;
    input.tabIndex = -1;
    input.className = 'fixed start-[-9999px] opacity-0';
    document.body.append(input);

    try {
      input.select();
      return document.execCommand?.('copy') === true;
    } catch {
      return false;
    } finally {
      input.remove();
      if (source.isConnected) source.focus({ preventScroll: true });
    }
  }

  #selectVisibleCode() {
    const code = this.querySelector('code');
    const selection = window.getSelection();
    if (!code || !selection) return;

    const range = document.createRange();
    range.selectNodeContents(code);
    selection.removeAllRanges();
    selection.addRange(range);
  }

  #announce(region, message) {
    cancelAnimationFrame(this.#announcementFrame);
    region.textContent = '';
    this.#announcementFrame = requestAnimationFrame(() => {
      if (region.isConnected) region.textContent = message || '';
    });
  }
}

customElements.define('s-copy-code', SCopyCode);
